import { combineReducers } from "redux";
import * as peticioEnCursReducer from "./peticioEnCurs";
import * as individusReducer from "./individus";
import * as formulariReducer from "./formulari";

const rootReducer = combineReducers({
  peticioEnCurs: peticioEnCursReducer.default,
  dades: individusReducer.default,
  formulari: formulariReducer.default
});

export default rootReducer;

export const getPeticioIndividusEnCurs = state =>
  peticioEnCursReducer.getPeticioEnCurs(state.peticioEnCurs);

export const getPeticioIndividusError = state => {
  peticioEnCursReducer.getPeticioError(state);
};

export const getIndividusLlistat = state =>
  individusReducer.getIndividusLlistat(state.dades);

export const getIndividusAsArray = state =>
  individusReducer.getIndividusAsArray(state.dades);

export const getIndividuPerId = state =>
  individusReducer.getIndividuPerId(state.dades);

export const getDadesIndividu = state =>
  individusReducer.getDadesIndividu(state.dades);

export const getIndividusActius = state =>
  individusReducer.getIndividusActius(state.dades);

export const getIndividusInactius = state =>
  individusReducer.getIndividusInactius(state.dades);

export const getIdIndividu = state =>
  individusReducer.getIdIndividu(state.dades);

export const getIndividusPerIndret = state =>
  individusReducer.getIndividusPerIndret(state.dades);

export const getMostrarErrors = state => state.formulari.mostrarErrors;
export const getDadesEditades = state => state.formulari.editades;
export const getDadesOriginals = state => state.formulari.originals;
export const getPeticioEnviarFormulariIndividuEnCurs = state =>
  state.formulari.peticioEnviarFormulariEnCurs;
export const getDadesIndrets = state => state.formulari.indrets;
export const getNumObservacions = state =>
  individusReducer.getNumObservacions(state.dades);
